import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-6 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hdukw8kiel4z">
        <h2 className="text-center font-heading text-xl font-extrabold uppercase text-petrol sm:text-3xl" data-id="element-43" data-mp="1ceqajelumhd2">
          Frequently asked questions
        </h2>
        <div className="mt-4 divide-y divide-petrol/10 overflow-hidden rounded-xl bg-white shadow-sm" data-id="element-44" data-mp="2a1gz0ard5863">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} data-id="element-45" data-mp="20281j7xahbez" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-3 py-3 text-left" data-id="element-46" data-mp="1v582vi2rraxw">
                  <span className="font-heading text-sm font-bold text-petrol sm:text-base" data-id="element-47" data-mp="jrx6ond5x1yu">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-sage transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-48" data-mp="1pn36q63ksv6l" />
                </button>
                {isOpen ? <p className="px-3 pb-3 text-sm leading-snug sm:text-base" data-id="element-49" data-mp="11wpb65ls8e79">
                    {faq.a}
                  </p> : null}
              </div>;
        })}
        </div>
      </div>
    </section>;
}